import { graphqlbase } from '../../../_graph/_graphqlbase'

class EventList extends graphqlbase {
  constructor (filter) {
    super(null)
    this.use_loader = false

    this.query = `query BasicEventQuery {
      nodeQuery(
        first: 50,
        filter: {
          conditions: [
            { operator: EQUAL, field: "type", value: ["event"] }
            { operator: BETWEEN, field:"field_event_date", value: ["`+ filter[0] +`", "`+ filter[1] +`"]}
           ]
        }
      ) {
        entities {
          ... on NodeEvent {
            entityId
            fieldEventDate {
              startDate 
              value
              endDate
              endValue
            }
          }
        }
      }
    }`
  }

  render (data) {
    //console.log(data)
   //alert('renderitis')
  }
}

export { EventList };